import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Toaster } from "@/components/ui/sonner";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ block: "start" }), 60);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

export const Layout = () => (
  <>
    <a href="#main" className="skip-link rounded-full bg-ink px-5 py-3 font-bold text-cream" data-testid="skip-link">
      Skip to content
    </a>
    <ScrollManager />
    <Header />
    <main id="main" tabIndex={-1} className="outline-none">
      <Outlet />
    </main>
    <Footer />
    <Toaster position="top-center" richColors />
  </>
);
